import React from 'react';
import { CheckCircle } from 'lucide-react';

interface SuccesModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel?: () => void; // optional
  confirmText?: string;
  cancelText?: string;
  disableCancel?: boolean; // new prop
}

const SuccesModal: React.FC<SuccesModalProps> = ({
  isOpen,
  title = 'Bevestigen',
  message,
  onConfirm,
  onCancel,
  confirmText = 'Ja, verwijderen',
  cancelText = 'Annuleren',
  disableCancel = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal">
      <div className="modal-content">
        {title && (
          <h2 className="flex-row-align justify-center">
            <CheckCircle color="green" size={24} />
            {title}
          </h2>
        )}
        <p>{message}</p>
        <div className="modal-actions">
          {onCancel && (
            <button className="cancel-btn" onClick={onCancel} disabled={disableCancel}>
              {cancelText}
            </button>
          )}
          <button className="confirm-btn" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccesModal;
